
const digest = '46b824090ffcfad41369a9f6dd2fded49658693036f44e2d360d5af277148fa3';
const classes = {"wrapper":"_wrapper_156nz_1","controls":"_controls_156nz_7","content":"_content_156nz_14","header":"_header_156nz_18"};
const css = `._wrapper_156nz_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  height: 100%;
}
._wrapper_156nz_1 ._controls_156nz_7 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}
._wrapper_156nz_1 ._content_156nz_14 {
  flex: 1;
  padding: 12px;
}
._wrapper_156nz_1 ._content_156nz_14 ._header_156nz_18 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  